import { Link } from "react-router-dom";
import { useT } from "@/lib/useSiteText";

interface PageHeroProps {
  titulo: string;
  descripcion?: string;
  imagen?: string;
  alt?: string;
}

export default function PageHero({ titulo, descripcion, imagen, alt }: PageHeroProps) {
  const t = useT();
  return (
    <section className="relative bg-primary-900 pt-32 md:pt-40 pb-16 md:pb-20 overflow-hidden">
      {imagen && (
        <img src={imagen} alt={alt ?? ""} className="absolute inset-0 w-full h-full object-cover object-top" />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-900/80 to-primary-900/85" />
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <nav className="text-xs md:text-sm text-background-300 flex items-center gap-2">
          <Link to="/" className="hover:text-background-50 transition">
            {t("comun.migas_inicio")}
          </Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-background-100">{titulo}</span>
        </nav>
        <h1 className="mt-4 font-heading font-bold text-3xl md:text-5xl text-background-50 max-w-3xl leading-tight">
          {titulo}
        </h1>
        {descripcion && (
          <p className="mt-4 text-base md:text-lg text-background-200 max-w-2xl leading-relaxed">{descripcion}</p>
        )}
      </div>
    </section>
  );
}